export enum TSaleStatus {
  pending = "pending",
  approved = "approved",
  rejected = "rejected",
  failed = "failed",
  refunded = "refunded",
  cancelled = "cancelled",
}

export type TClientDetails = {
  email: string;
  full_name: string;
  cellphone: string;
  birthdate: string;
  cpf: string;
  gender: string;
  zip: string;
  address: string;
  number: string;
  complement: string;
  district: string;
  city: string;
  state: string;
  external_customer_id: number;
};

export type TProduct = {
  id: string;
  name: string;
  description: string;
  price: number;
  insurance_company_name?: string;
};

export type TPlanDetails = {
  id: string;
  name: string;
  description: string;
  products: TProduct[];
};

export type TSale = {
  id: string;
  plan_name: string;
  partner_name: string;
  client_name: string;
  client_cpf: string;
  sale_price: number;
  status: TSaleStatus;
  sale_date: Date;
  client_details: TClientDetails;
  plan_details: TPlanDetails;
  product_id?: string;
  product_name?: string;
  product_value?: number;
};

export type TReportsFilters = {
  status?: TSaleStatus | string;
  partner_name?: string;
  client_name?: string;
  client_cpf?: string;
  sale_id?: string;
  start_date?: Date;
  end_date?: Date;
};

// Tipos da API
export type TSaleReportFilters = {
  sale_id?: string;
  status?: "paid" | "pending" | "failed" | "refunded";
  partner?: string;
  customer_name?: string;
  customer_cpf?: string;
  value_sale?: {
    min?: number;
    max?: number;
  };
  sale_date?: {
    start_date?: string; // ISO date format
    end_date?: string; // ISO date format
  };
  insurance_company_id?: string;
  product_id?: string;
  page?: number;
  limit?: number;
};

export type TSalesReportResponse = {
  data: TSaleListItem[];
  metadata: {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
    has_next: boolean;
    has_previous: boolean;
  };
};

export type TSaleListItem = {
  sale_id: string;
  status: string;
  /** Valor em centavos (BRL); o painel divide por 100 para exibição */
  value_sale: number;
  sale_date: string; // ISO date format
  customer_name: string;
  customer_cpf: string;
  partner: string;
  plan_name: string;
  plan_description: string;
  product_id?: string;
  product_name?: string;
  product_value?: number;
};

export type TSaleDetailsResponse = {
  sale_info: {
    sale_id: string;
    transaction_search_id: string;
    sale_date: string; // ISO date format
    partner: string;
    total_amount: number;
    status: string;
  };
  customer: {
    full_name: string;
    email: string;
    cpf: string;
    cellphone: string;
    birthdate: string; // ISO date format
    gender: string;
    address: {
      cep: string;
      street: string;
      number: string;
      complement: string;
      neighborhood: string;
      city: string;
      state: string;
    };
  };
  plan: {
    plan_id: string;
    plan_name: string;
    description: string;
    products: Array<{
      product_id: string;
      product_name: string;
      description: string;
      price: number;
      insurance_company_id?: string;
      insurance_company_name?: string;
    }>;
    total: number;
  };
};
